/// <reference types="vite-plugin-svgr/client" />

import { FC, useCallback, useRef } from "react";
import QuickPinchZoom, { make3dTransformValue, UpdateAction } from "react-quick-pinch-zoom";
//import SvgMap from "../assets/campus-map-circled.svg?react";
import SvgMap from "../assets/montgomerycampus.svg?react";
import { Button, Text } from "@fluentui/react-components";

interface IConferenceMapProps {}

const ConferenceMap: FC<IConferenceMapProps> = () => {
  const svg = useRef<HTMLDivElement>(null);
  //const svg = createRef<SVGElement>();
  const zoom = useRef<QuickPinchZoom>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onUpdate = useCallback(
    (action:UpdateAction) => {
      const { current: img } = svg;

      if (img) {
        const value = make3dTransformValue(action);
        
        img.style.setProperty("transform", value);
      }
    },
    [svg]
  );

  const resetView = () => {
    const { current: img } = svg;
    if (img)  {
      zoom.current?.scaleTo({ x: 0, y: 0, scale: 1 });
    }
  };

  return (
    <div>
      <Text>Pinch to zoom or use the mouse wheel.</Text>
      <Button onClick={resetView}>Reset Zoom</Button>
      <div style={{ overflow: "hidden" }}>
        <QuickPinchZoom ref={zoom} onUpdate={onUpdate} zoomOutFactor={1} shouldInterceptWheel={() => false}>
          <div ref={svg} >
            <SvgMap preserveAspectRatio="xMinYMin meet" style={{overflow: "hidden", width:'100%'}}/>
          </div>
         
        </QuickPinchZoom>
      </div>
      
    </div>
  );
};

export default ConferenceMap;
